import React, { useCallback, useContext } from 'react';

import { CanadianOptIn as CanadianOptInComponent } from '../../../components/ui/Inputs/CanadianOptIn';
import { useEvent } from '../../../utils/analytics/useEvent';
import { SignUpFormContext } from '../SignUpFormContext';

export function CanadianOptIn() {
  const trackEvent = useEvent();
  const { bindCanadianOptIn, isLoading } = useContext(SignUpFormContext);

  const onContactUsClick = useCallback(() => {
    trackEvent('identity – mlife registration - external link click', 'MGM Resorts Properties', 'mliferegclicks');
  }, [trackEvent]);

  return <CanadianOptInComponent onContactUsClick={onContactUsClick} disabled={isLoading} {...bindCanadianOptIn} />;
}
